import React                         from 'react';
import { connect }                   from 'react-redux';
import { Link }                      from 'react-router-dom';
import FlashCarregando               from '../../../container/FlashCarregando';
import EquipeProfessorTurmaAlunoList from './equipe_professor_turma_aluno_list';
import { GetGruposAlunos,Dados_tur_dis}            from '../../../actions/grupoAction';
import { SetError }                  from '../../../actions/authenticActions';
import { GetListaMenuTopo,
    GetListaSubMenuTopo,
    ActionModal }       from '../../../actions/scopoAction';

class Equipe_Professor_Turma_Aluno extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
                        load   : false,
                        errors : {},
                        equ_id : this.props.match.params.id,
                        dis_id : this.props.match.params.id2,
                        tur_id : this.props.match.params.id3,
                        use_id : this.props.session.id
                     }

        this.props.Dados_tur_dis(this.state.tur_id,this.state.dis_id);

        //console.log(props);
    }

    componentWillMount(){

       this.props.GetGruposAlunos(this.state.equ_id).then((response) => {

         this.setState({ load : true })
       }).catch((error) => {
         this.props.SetError(500);
       });

       this.props.GetListaMenuTopo([
                                      {
                                       action : true,
                                       nome   : "Home",
                                       link   : this.props.menu.home
                                      },
                                      {
                                       action : true,
                                       nome   : 'Unidade Curricular',
                                       link   : this.props.menu.equipe.professor.home
                                      },
                                      {
                                       action : true,
                                       nome   : 'Equipes',
                                       link   :`${this.props.menu.equipe.professor.equipe_turma}/${this.state.tur_id}/${this.state.dis_id}`
                                      },
                                      {
                                       action : false,
                                       nome   : 'Alunos'
                                      }

                                   ]);

       this.props.GetListaSubMenuTopo([]);
    }

    render() {

        return (
                <div>
                    <div className="container-bg">
                      
                        <div className="titulo-pages topo_conteudo">
                            <div className="titulo">Alunos da equipe <strong>{(this.props.dados_turma ? this.props.dados_turma.tur_nome:"")}</strong></div>
                            {/*<button onClick={()=>this.props.ActionModal(true)} className="btn btn-primary pull-right"> + adicionar</button>*/}
                            <button onClick={()=>this.props.ActionModal(true)} className="btn btn-success pull-right btn-space-left"><span className="glyphicon glyphicon-plus"></span> adicionar alunos</button>
                            <Link to={`${this.props.menu.equipe.professor.equipe_turma}/${this.state.tur_id}/${this.state.dis_id}`}><button className="btn btn-default pull-right"><span className="glyphicon glyphicon-chevron-left"></span> voltar</button></Link>

                        </div>   
                        {!this.state.load ? <FlashCarregando /> : <EquipeProfessorTurmaAlunoList equ_id = {this.state.equ_id} /> }
                    </div>                
                </div>
                );
    }

}

function mapStateToProps(state){

        return {
               session : state.auth.session,
               menu    : state.configReducer.menu,
               dados_turma: state.equipeReducer.dados_turma
        };
  }

export default connect(mapStateToProps, { GetGruposAlunos, 
                                          SetError,
                                          GetListaMenuTopo,
                                          GetListaSubMenuTopo,
                                          Dados_tur_dis,
                                          ActionModal 
                                         })(Equipe_Professor_Turma_Aluno)






// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor_turma_aluno.js